import { render, staticRenderFns } from "./AvTopView.vue?vue&type=template&id=2dfec895&scoped=true"
import script from "./AvTopView.vue?vue&type=script&lang=js"
export * from "./AvTopView.vue?vue&type=script&lang=js"
import style0 from "./AvTopView.vue?vue&type=style&index=0&id=2dfec895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfec895",
  null
  
)

export default component.exports